import type {
  TPlayerBrightnessControl,
  TPlayerBrightnessMethod,
  TPlayerBrightnessMode
} from '@lucimark/shared/models/player-brightness'
import {
  playerBrightnessControlSchema,
  playerBrightnessMethodSchema,
  playerBrightnessModeSchema
} from '@lucimark/shared/models/player-brightness'

export interface IAndroidBrightnessStatus {
  /** Omitted when the device could not report a level. */
  brightnessPercent?: number
  brightnessMode: TPlayerBrightnessMode
  brightnessControl: TPlayerBrightnessControl
  brightnessMethod: TPlayerBrightnessMethod
  writeSettingsGranted: boolean
}

export function parseAndroidBrightnessStatus(raw: unknown): IAndroidBrightnessStatus | null {
  if (raw == null || typeof raw !== 'object') {
    return null
  }
  const o = raw as Record<string, unknown>
  const mode = playerBrightnessModeSchema.safeParse(o.brightnessMode)
  const control = playerBrightnessControlSchema.safeParse(o.brightnessControl)
  const method = playerBrightnessMethodSchema.safeParse(o.brightnessMethod)
  if (!mode.success || !control.success || !method.success || typeof o.writeSettingsGranted !== 'boolean') {
    return null
  }
  const status: IAndroidBrightnessStatus = {
    brightnessMode: mode.data,
    brightnessControl: control.data,
    brightnessMethod: method.data,
    writeSettingsGranted: o.writeSettingsGranted
  }
  if (typeof o.brightnessPercent === 'number' && Number.isFinite(o.brightnessPercent)) {
    status.brightnessPercent = Math.min(100, Math.max(0, Math.round(o.brightnessPercent)))
  }
  return status
}
